import React, { useState, useEffect, useRef } from "react";
import classNames from "classnames";
import Frame from "react-frame-component";

import Preview from "../Preview";
import Theme from "../Theme";

const Mobile = props => {
  const frame = useRef(null);
  const [landscape, setLandscape] = useState(false);
  const [broken, setBroken] = useState(false);
  const [clicks, setClicks] = useState(0);
  const [locked, setLocked] = useState(true);
  const [showLocked, setShowLocked] = useState(true);

  useEffect(() => {
    const timer = setTimeout(
      () => {
        setLocked(!props.on);
      },
      props.on ? 300 : 0
    );
    return () => clearTimeout(timer);
  }, [props.on]);

  useEffect(() => {
    const timer = setTimeout(
      () => {
        setShowLocked(locked);
      },
      locked ? 0 : 300
    );
  }, [locked]);

  useEffect(() => {
    setClicks(clicks + 1);
    return () => {};
  }, [landscape]);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (clicks >= 33) setBroken(true);
      setClicks(0);
    }, 1000);
    return () => clearTimeout(timer);
  }, [clicks]);

  const previewClasses = classNames("preview-phone", {
    landscape: landscape
  });
  const toggleButtonClasses = classNames(
    "fi",
    { "fi-rotate-phone-landscape": landscape },
    { "fi-rotate-phone": !landscape }
  );

  const bodyClasses = classNames("preview-phone__body", {
    "preview-phone__body--broken": broken,
    "preview-phone__body--locked": locked
  });

  const html =
    "<!DOCTYPE html><html xmlns='http://www.w3.org/1999/xhtml'><head><meta content='text/html; charset=utf-8' http-equiv='Content-Type'><meta content='width=device-width' name='viewport'></head><body style='margin: 0'></body></html>";

  return (
    <div className="preview-mobile">
      <div className="preview-mobile-wrapper">
        <div
          className="preview-mobile-wrapper__toggle"
          onClick={() => setLandscape(!landscape)}
        >
          <i className={toggleButtonClasses} />
        </div>
        <div className="preview-mobile-wrapper__preview">
          <div className={previewClasses}>
            <div className={bodyClasses}>
              {(showLocked || !props.on) && (
                <div
                  className="preview-phone__locked"
                  style={{ opacity: locked ? 1 : 0 }}
                />
              )}
              {props.on && (
                <Frame
                  className="preview-phone__screen"
                  initialContent={html}
                  mountTarget="body"
                >
                  <Theme mobile />
                  <Preview mobile landscape={landscape} />
                </Frame>
              )}
              <div className="preview-phone__home" />
              <div className="preview-phone__speaker" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Mobile;
